<template>
  <div :class="currentScreen">
    <div class="card__inner">
      <vue-audio :file="3" ref="btnClick" :redirect="redirect"></vue-audio>
      <vue-audio :file="4" ref="sufferCard" :loop="true"></vue-audio>
      <vue-audio :file="5" ref="setUnicorn" :redirect="redirect"></vue-audio>
      <p v-html="cardPageTitle[currentScreen]"></p>
      <card-spec :specId="'horseUser'" :specCard="specUser"></card-spec>
      <card-list :horseColor="horseColor" :cardId="cardId" @update:cardId="cardId => chooseSpecialCard(cardId)" :itemCard="itemCard"></card-list>
      <card-spec :specId="'horsePc'" :specCard="specPc" v-show="currentScreen === 'decisionCard'"></card-spec>
      <div class="card__action--button">
        <!-- Show button case select card screen -->
        <template v-if="currentScreen === 'card'">
          <button @click="sufferCard" class="btn" :class="[!isSelected ? btnStart : btnTop, disableSufferCard]"><span><img src="../assets/image/txt_stop.png" alt="" v-show="isSelected"><img src="../assets/image/txt_select_card.png" alt="" v-show="!isSelected"></span></button>
          <button @click="decisionCard" class="btn btn__decision__card am-btn-01" :class="disableClass"><!--<span>決定して<br>確認する</span>--><span><img src="../assets/image/txt_decision_card.png" alt=""></span><span></span></button>
        </template>
        <!-- Show button case decide card screen -->
        <template v-else-if ="isDecisionCardScreen">
          <button @click="goRace" class="btn btn__decision__card am-btn-02"><span><img src="../assets/image/txt_decision_card_decisionCardScreen.png" alt=""></span></button>
          <button @click="backSelectCard" class="btn btn__select__card am-btn-03"><span><img src="../assets/image/txt_select_card_decisionCardScreen.png" alt=""></span></button>
        </template>
        <!-- Show button case decide card screen -->
        <template v-else-if ="currentScreen === 'specialCard'">
          <p>変更したいカード<br>をクリックしてね</p>
          <button @click="decisionCard" class="btn btn__decision__card am-btn-01" :class="!isSelectedSpecialCard ? 'inactive' : ''"><span><img src="../assets/image/txt_decision_card.png" alt=""></span></button>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import { store } from '../store/store'
  import List from './CardList'
  import Spec from './CardSpec'
  import Audio from './Audio'
  import _ from 'lodash'
  export default {
    name: 'Card',
    data () {
      return {
        msg: 'Card screen!',
        // isUser: true
        cardPageTitle: {
          'card': 'ゲノムカードでユニコーンのスペックを決めよう',
          'decisionCard': '競争相手のユニコーンのスペックを見てみよう',
          'specialCard': '<span>CRISPR-CAS</span>カードに変更するカード１枚を選ぼう！'
        },
        isSelected: false,
        card: {
          speed: '',
          stamina: '',
          brave: '',
          calm: '',
          health: '',
          sex: ''
        },
        specUser: {},
        specPc: {},
        itemCard: {},
        horseColor: '',
        timeLine: -1,
        timeLine2: -1,
        disableClass: 'inactive',
        cardId: '',
        btnTop: 'btn__select__stop',
        btnStart: 'btn__select__card',
        redirect: '',
        disableSufferCard: ''
      }
    },
    created () {
      this.disableSufferCard = ''
      this.timeLine = new TimelineMax()
      store.dispatch('setCardSuffer', false)
      if (this.isReplay) {
        this.isSelected = true
        this.sufferCard()
      }
    },
    computed: {
      currentScreen () {
        return store.state.currentScreen
      },
      isStop () {
        return store.state.isStopSufferCard
      },
      isDecisionCardScreen () {
        return this.currentScreen === 'decisionCard'
      },
      isReplay () {
        return store.state.replay
      },
      isSelectedSpecialCard () {
        return store.state.adnSpecial !== -1
      }
    },
    components: {
      'card-spec': Spec,
      'card-list': List,
      'vue-audio': Audio
    },
    methods: {
      start () {
        store.dispatch('setCurrentScreen', 'match')
      },
      sufferCard: _.throttle(function () {
        if (this.disableSufferCard !== 'inactive') {
          this.isSelected = !this.isSelected
          store.dispatch('setCardSuffer')
          // Play audio button click
          if (this.$refs.btnClick) {
            this.$refs.btnClick.play()
          }
          if (this.isSelected) {
            // Play audio suffer
            if (this.$refs.sufferCard) {
              this.disableClass = 'inactive'
              this.$refs.sufferCard.play()
//            setTimeout(() => { this.$refs.sufferCard.play() }, 150)
            }
            this.btnTop = 'btn__select__stop inactive'
            this.setDefaultCard()
            this.backCard(this.startEvent)
            this.btnTop = 'btn__select__stop'
//          this.disableClass = ''
//          setTimeout(() => { this.btnTop = 'btn__select__stop' }, 700)
          } else {
            // Stop audio suffer
            if (this.$refs.sufferCard) {
              this.$refs.sufferCard.stop()
            }
            this.btnStart = 'btn__select__card'
            this.frontCard(this.stopEvent)
            this.btnTop = 'btn__select__stop'
            this.disableClass = ''
//          setTimeout(() => { this.btnStart = 'btn__select__card' }, 700)
          }
        }
      }, 1000),
      decisionCard () {
        if (this.disableClass !== 'inactive') {
          this.disableSufferCard = 'inactive'
          const timeLine = new TimelineMax()
          timeLine.append(TweenMax.to('.am-btn-01', 0.2, {y: -6, ease: Circ.easeNone, repeat: 3, yoyo: true}))
          this.redirect = 'decisionCard'
          this.$refs.setUnicorn.play()
        }
      },
      frontCard (complete) {
        TweenLite.to('.card-item__inner', 0.5, {rotationY: 180, ease: Power0.easeNone, onComplete: complete})
        TweenLite.to('.card-face.front', 0.5, {opacity: 0, ease: Power0.easeNone, onComplete: complete})
        TweenLite.to('.card-face.back', 0.5, {opacity: 1, ease: Power0.easeNone, onComplete: complete})
        TweenLite.set('.card-face.back li', {opacity: 1})
      },
      backCard (complete) {
        TweenLite.to('.card-item__inner', 0.5, {rotationY: 0, ease: Power0.easeNone, onComplete: complete})
        TweenLite.to('.card-face.front', 0.5, {opacity: 1, ease: Power0.easeNone, onComplete: complete})
        TweenLite.to('.card-face.back', 0.5, {opacity: 0, ease: Power0.easeNone, onComplete: complete})
        TweenLite.set('.card-face.back li', {opacity: 0})
      },
      setDefaultCard () {
        TweenLite.set('.card-item', {perspective: 800})
        TweenLite.set('.card-item__inner', {transformStyle: 'preserve-3d'})
        TweenLite.set('.back', {rotationY: -180})
        TweenLite.set('.card-face', {backfaceVisibility: 'none'})
      },
      backSelectCard () {
        this.disableSufferCard = ''
        this.redirect = store.state.replaySpecialcard ? 'specialCard' : 'card'
        this.$refs.btnClick.play()
        // store.dispatch('setCurrentScreen', store.state.replaySpecialcard ? 'specialCard' : 'card')
      },
      goRace () {
        const timeLine = new TimelineMax()
        timeLine.append(TweenMax.to('.am-btn-02', 0.2, {y: -6, ease: Circ.easeNone, repeat: 3, yoyo: true}))
        this.redirect = 'race'
        this.$refs.btnClick.play()
        // store.dispatch('setCurrentScreen', 'race')
      },
      chooseSpecialCard (cardId) {
        if (this.currentScreen === 'specialCard') {
          store.dispatch('setSpecialCard', cardId)
          _.assignIn(this.specUser, store.state.specialCard)
          _.cloneDeep(this.itemCard[cardId], store.state.arraySpecialDNA[cardId])
          this.horseColor = 'horse-0' + store.state.specialCard.color
        }
      },
      startEvent () {
        store.dispatch('setHorseStatus')
        _.assignIn(this.specUser, this.card)
        _.assignIn(this.specPc, this.card)
        _.assignIn(this.itemCard, this.card)
        this.horseColor = ''
      },
      stopEvent () {
        store.dispatch('setStopSufferCard', true)
        this.specUser = store.state.horseUser
        this.specPc = store.state.horsePc
        this.itemCard = store.state.arrayTotalDNA
        this.horseColor = 'horse-0' + store.state.horseUser.color
        this.disableClass = ''
//        setTimeout(() => { this.disableClass = '' }, 100)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Card.vue?c5387640